import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.span`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	align-content: center;
	justify-items: center;
	justify-content: center;

	svg {
		width: 100%;
		height: 100%;
	}
`;

const Pictogram = ({ svg }) => (
	<Container className="pictogram-icon" dangerouslySetInnerHTML={{__html: svg }} />
);

Pictogram.propTypes = {
	svg: PropTypes.string,
};

export default Pictogram
